import { render, staticRenderFns } from "./is-required.vue?vue&type=template&id=94f563b4"
import script from "./is-required.vue?vue&type=script&lang=js"
export * from "./is-required.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports